import { SIZES } from 'src/styles/theme'
import styled from 'styled-components'
import bannerBg from '../../images/backdrops/banner_bg.png'

export const AgendaStyle = styled.div`
  background: white;
  padding-top: ${SIZES.navHeight};
  .header-banner {
    background-image: url(${bannerBg});
    background-position: center top;
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 0;
    margin-bottom: 48px;
    position: sticky;
    z-index: 10;
  }
  .agenda-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
    grid-auto-rows: max-content;
    margin-bottom: 5rem;
  }
 
  .mobile-hide {
    display: block !important;
  }
  .mobile-show {
    display: none !important;
  }
  .right-section {
    display: flex;
    flex-direction: column;
    width: 20%;
    margin-right: 30px;
  }
`